// Tab «Люди» of a talk (В6): its speakers with who manages their pages, and the PC people of the talk — curators and declared conflicts.
import { FieldList, LinkedTable } from '@confdeck/core-web';

export function TalkPeople({ recordId }: { recordId: string }) {
  return (
    <>
      <LinkedTable recordId={recordId} field="speakers" title="Докладчики" columns={['name', 'email', 'company', 'main_owner', 'owners']} empty="Докладчиков нет" />
      <FieldList recordId={recordId} title="Программный комитет" fields={['curator', 'co_curators', 'conflicts']} />
    </>
  );
}
